<siq-activity-options
  (click)="$event.stopPropagation();"
  *ngIf="actions"
  [activity]="activity"
  [callbacks]="callbacks"
  [actions]="actions"
></siq-activity-options>
